import { Component, Input, Output } from '@angular/core';
import { CONSTANTS } from '@pk/powerkioskutils';

import { confirm } from 'devextreme/ui/dialog';
import _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

import { environment } from '../../../environments/environment';
import { GraphqlService } from '../../graphql/graphql.service';
import { RfqSession, RfqSessionBid } from '../../shared/models';

@Component({
	selector: 'pk-broker-auction-supplier-bids',
	templateUrl: './auction-supplier-bids.component.html',
	styleUrls: ['./auction-supplier-bids.component.scss'],
	standalone: false,
})
export class AuctionSupplierBidsComponent {
	@Output() deletedBid: Subject<string> = new Subject();

	@Input() rfqSession: RfqSession;
	@Input() rfqSessionSupplierId: string;

	public warnings = [];
	public environment = environment;

	constructor(
		private graphqlService: GraphqlService,
		private toastrService: ToastrService,
	) {}

	get units() {
		return this.rfqSession?.contract.serviceTypeId === CONSTANTS.serviceTypes.naturalGas.serviceTypeId ? '$/DTH' : '$/MWh';
	}

	public async removeBid(bid: RfqSessionBid): Promise<void> {
		this.warnings = [];
		try {
			const result = await confirm('Are you sure you want to remove this bid?', 'Confirm');
			if (result) {
				bid.removing = true;
				const rfqSessionResult = await this.graphqlService.deleteRfqSessionBid(bid.rfqSessionBidId);
				if (rfqSessionResult) {
					this.rfqSession.bids.splice(
						this.rfqSession.bids.findIndex(b => b.rfqSessionBidId === bid.rfqSessionBidId),
						1,
					);
					this.rfqSession.bids = _.clone(this.rfqSession.bids); // force pipe
					this.deletedBid.next(bid.rfqSessionBidId);
					this.toastrService.success('Successfully removed!', 'Pricing Session');
				} else {
					this.warnings = [
						'There was a problem deleting the bid. We have been notified and are working to fix the issue. Please check back again in 30 minutes.',
					];
				}
			}
		} catch (e) {
			this.warnings = [
				'There was a problem deleting the bid. We have been notified and are working to fix the issue. Please check back again in 30 minutes.',
			];
		}
		bid.removing = false;
	}
}
